// extracted by mini-css-extract-plugin
export var avatarContainer = "_83-0";
export var avatarTypingWave = "_83-i";
export var gray = "_83-f";
export var green = "_83-c";
export var icon = "_83-9";
export var image = "_83-1";
export var lg = "_83-6";
export var md = "_83-5";
export var presenceDot = "_83-b";
export var red = "_83-d";
export var sm = "_83-4";
export var status = "_83-a";
export var typingDot = "_83-h";
export var typingPill = "_83-g";
export var xl = "_83-7";
export var xs = "_83-3";
export var xxl = "_83-8";
export var xxs = "_83-2";
export var yellow = "_83-e";